import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OverlappingIconsButton } from './OverlappingIconsButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const SourcesButton = ({
  count = 0,
  icons = [],
  onClick,
  selected = false
}) => {
  if (count === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(OverlappingIconsButton, {
    icons: icons,
    onClick: onClick,
    selected: selected,
    backgroundColor: "fill-secondary-default",
    selectedBackgroundColor: "fill-tertiary-hover",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderStyle: "solid",
    selectedBorderColor: "fill-tertiary-hover",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiComponentsUiLibrary.components.sourcesButton",
        options: {
          count
        }
      })
    })
  });
};